import { render, staticRenderFns } from "./insertAccount.vue?vue&type=template&id=2c7555e4&scoped=true"
import script from "./insertAccount.vue?vue&type=script&lang=js"
export * from "./insertAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7555e4",
  null
  
)

export default component.exports